(function LivePlannerSummary($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		var pages = [
			'/Clients/liveplanner',
			'/Clients/timeline/',
			'/Clients/touchpoints/',
			'/ClientOpportunities/timeline/',
			'/ClientOpportunities/touchpoints/',
			'/LivePlanner/sessions',
			'/LivePlanner/history',
		];

		Adzuki.onload(pages, function onload()
		{
			// when selecting an option from the "Actions" dropdown
			$('.session-actions').on('change', function _onOptionChange(e) {
				var action      = $(this).val();
				var action_data = $(this).find('option:selected').data('url');

				// nothing selected
				if (!action) {
					return;
				}

				$(this).val('');

				switch (action) {
					case 'share':
						document.location = Adzuki.base_uri + action_data;
						break;
					case 'send_email':
						document.location = Adzuki.base_uri + action_data;
						break;
					case 'view_email':
						_openFollowUpEmails(action_data);
						break;
					case 'notes':
						_viewSessionNotes(action_data);
						break;
					case 'view':
						action_data = action_data.split('|');
						_viewSessionSummary(action_data[0], action_data[1]);
						break;
					case 'edit':
						document.location = Adzuki.base_uri + action_data;
						break;
					case 'delete':
						Adzuki.CustomConfirm({
							title  : 'Decision Time',
							content: 'Are you sure you wish to delete this session?',
							confirm: function confirm() {
								document.location = Adzuki.base_uri + action_data;
							}
						});
						break;
					case 'recording':
						_viewSessionRecording(action_data);
						break;
					default:
						// do nothing
						break;
				}
			});

			$('.lp-session').on('click', function _showSummary(e) {
				var lp_session_id = $(this).data('lp-session');
				var client_id     = $(this).data('client-id');

				e.preventDefault();

				_viewSessionSummary(lp_session_id, client_id);
			});

			$('.lp-session-notes').on('click', function _showNotes(e) {
				var lp_session_id = $(this).data('lp-session');

				e.preventDefault();

				_viewSessionNotes(lp_session_id);
			});

			$('.lp-follow-up-emails').on('click', function _showEmails(e) {
				var url = $(this).data('url');

				e.preventDefault();

				_openFollowUpEmails(url);
			});

			$('#modalWindow').on('click', '.lp-follow-up-body-link', function _showBody(e) {
				var content = $.parseJSON($(this).data('content')),
					iframe  = '<iframe id="message-body" style="width: 100%; height: 600px; border: none"></iframe>';

				e.preventDefault();

				iframe += '<br><a href="#" class="lp-follow-up-body-close"><i class="fas fa-window-close"></i> Close email</a>';
				$('.lp-follow-up-body').html(iframe);
				$('#message-body').prop('src', "data:text/html;charset=utf-8," + escape(content));
			});

			$('#modalWindow').on('click', '.lp-follow-up-body-close', function _closeBody(e) {
				e.preventDefault();
				$('.lp-follow-up-body').html('');
			});

		}, false);
	});

	function _openFollowUpEmails(url)
	{
		var $modal = $('#modalWindow');

		$modal.find('.modal-body').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Loading Follow-up Emails...');
		$modal.find('.modal-title').text('LivePlanner Follow-up Emails');
		$modal.modal('show');

		Adzuki.Ajax.get(url)
		.then(function _showEmails(response) {
			$modal.find('.modal-body').html(response);
		});
	}

	function _viewSessionNotes(lp_session_id)
	{
		var $modal = $('#modalWindow');

		$modal.find('.modal-body').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Loading LivePlanner session notes...');
		$modal.find('.modal-title').text('LivePlanner Session Notes');
		$modal.modal('show');

		Adzuki.Ajax.get('/LivePlanner/notes/' + lp_session_id)
		.then(function _notes(response) {
			$modal.find('.modal-body').html(response);
		});
	}

	function _viewSessionRecording(url)
	{
		var $modal = $('#modalWindow');
		var icon   = Adzuki.FaIcon.getIconStyle('spinner');

		$modal.find('.modal-body').html('<i class="' + icon + ' fa-spin fa-2x"></i>&nbsp;Loading LivePlanner session recording...');
		$modal.find('.modal-title').text('LivePlanner Session Recording');
		$modal.find('.modal-dialog').addClass('modal-medium');
		$modal.modal('show');

		// re-adjust the size once closed
		$modal.on('hidden.bs.modal', function modalClosed(e) {
			$modal.find('.modal-dialog').removeClass('modal-medium');
		});

		Adzuki.Ajax.get(url)
		.then(function _viewRecording(response) {
			$modal.find('.modal-body').html(response);

			// handler to copy the passcode
			$('.copy-passcode-btn').off().on('click', function _onCopyPasscodeClick(e) {
				var $passcode_field = $('.recording-passcode');

				e.preventDefault();

				$passcode_field.select();
				document.execCommand('copy');
				Adzuki.StatusMessage('success', 'The Passcode has been copied into your clipboard');
			});
		});
	}

	function _viewSessionSummary(lp_session_id, client_id)
	{
		var $modal = $('#modalWindow');

		$modal.find('.modal-body').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Loading LivePlanner summary...');
		$modal.find('.modal-title').text('LivePlanner Summary Preview');
		$modal.modal('show');

		Adzuki.Ajax.get('/LivePlanner/summary/' + lp_session_id + '/' + client_id)
		.then(function showDetails(response) {
			var content = '<iframe src="' + response + '" style="width: 100%; height: 800px;"></iframe>';
			$modal.find('.modal-body').html(content);
		});
	}
}(jQuery, window.Adzuki || {}));
